// extracted by mini-css-extract-plugin
module.exports = {"baseLayout":"MainLayout_baseLayout__ENFVv","content":"MainLayout_content__41Os-"};